import { getRequestListLight } from '../../../../api'
import {
  ASYNC_SELECT_LOAD_ALL_PAGE_SIZE_PARAMS,
  getAsyncSelectShowSelectedApiParamIdPK,
  InputAsyncSelect as InputAsyncSelectComponent,
  InputMultiSelectControl,
} from '../../../Select'
import { Container } from '../../Container'
import { useSelectState } from '../Selects.hooks'
import { toRequestAsyncSelectItems } from '../Selects.utils'

import ServiceRequestIcon from '../../../../icons/service-request.svg'

function InputAsyncMultiSelect() {
  const { handleClear, handleSelectAll, handleSelectItem, value } =
    useSelectState({
      multi: true,
    })

  return (
    <Container label='Async input multi select with search input inside control'>
      <InputAsyncSelectComponent
        multi
        Control={InputMultiSelectControl}
        EntityIcon={ServiceRequestIcon}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: 'Select',
            },
          },
        }}
        getData={getRequestListLight}
        getShowSelectedApiParam={getAsyncSelectShowSelectedApiParamIdPK}
        loadAllApiParams={ASYNC_SELECT_LOAD_ALL_PAGE_SIZE_PARAMS}
        style={{ width: 240 }}
        toPreparedItems={toRequestAsyncSelectItems}
        value={value}
        onClear={handleClear}
        onSelectAll={handleSelectAll}
        onSelectItem={handleSelectItem}
      />
    </Container>
  )
}

export default InputAsyncMultiSelect
